// @ts-nocheck
import React, {Component} from 'react';
import styles from '../css/Details_Edit_AffiliationsConfirmation.module.css';
import Icon from '../../../components/Icon/Icon';

class Details_Edit_AffiliationsConfirmation extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <div className={styles.editScreen}>
                <div className={styles.title}>
                    <div></div>
                    <div className={styles.TitleText}>Edit Affiliations</div>
                    <div className={styles.close} onClick={() => {
                        this.props.close();
                    }}><span aria-hidden="true">×</span></div>
                </div>
                <div className={styles.body}>
                    <div id={styles.SuccessIcon}>
                        <Icon name="check-circle" />
                    </div>
                    <div className={styles.TextBox}>
                        Affiliations have been updated!
                    </div>
                </div>
            </div>
        )
    }
}

export default Details_Edit_AffiliationsConfirmation;
